import React, { Component } from "react";

import "./TableComponent.css";

//This TableComponent can be used as common table for all Table UIs with some necessary changes
//But for now it suits only for viewclaims and related claims tables
//More chagnes are needed to make this component more generic one
export default class TableComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
      prevDataSource: [],
      sortColumn: "",
      selectedRowId: "",
      currentPage: 1,
      sortOrder: "ascending",
      searchKey: ""
    };
    this.dataPerPage = 5;
  }

  static getDerivedStateFromProps(props, state) {
    if (props.dataSource !== state.dataSource) {
      return {
        dataSource: props.dataSource
      };
    }
    return null;
  }

  previousPage = event => {
    if (this.state.currentPage === 1) {
      event.nativeEvent.stopImmediatePropagation();
      return;
    }
    const currentPageNo = this.state.currentPage - 1;
    this.setState({ currentPage: currentPageNo });
    event.stopPropagation();
  };

  nextPage = event => {
    if (this.state.currentPage === this.totalPages) {
      event.nativeEvent.stopImmediatePropagation();
      return;
    }
    const currentPageNo = this.state.currentPage + 1;
    this.setState({ currentPage: currentPageNo });
    event.stopPropagation();
  };



  resetTableSelectedData = () => {
    this.setState({
      selectedRowId:""
    })
  }


  toggleSort(id, event) {
    let stateData = this.state.dataSource;
    let statusSortOrder = [
      "action needed",
      "submitted",
      "in process",
      "completed"
    ];
    switch (id) {
      case "DateSubmitted":
        stateData.sort((claim1, claim2) => {
          let date1 = new Date(claim1.DateSubmitted);
          let date2 = new Date(claim2.DateSubmitted);
          if (this.state.sortOrder === "ascending") return date1 - date2;
          return date2 - date1;
        });
        break;

      case "ClaimID":
        stateData.sort((claim1, claim2) => {
          if (claim1.ClaimNumber || claim2.ClaimNumber === null) return 0;
          else {
            let claimNo1 = claim1.ClaimNumber.toLowerCase();
            let claimNo2 = claim2.ClaimNumber.toLowerCase();
            if (this.state.sortOrder === "ascending") {
              if (claimNo1 < claimNo2) return -1;
              if (claimNo1 > claimNo2) return 1;
            } else {
              if (claimNo1 < claimNo2) return 1;
              if (claimNo1 > claimNo2) return -1;
            }
            return 0;
          }
        });
        break;

      case "PetName":
        stateData.sort((claim1, claim2) => {
          let pet1 = claim1.PetName.toLowerCase();
          let pet2 = claim2.PetName.toLowerCase();
          let date1 = new Date(claim1.DateSubmitted);
          let date2 = new Date(claim2.DateSubmitted);
          if (this.state.sortOrder === "ascending") {
            if (pet1 === pet2) {
              return date1 - date2;
            }
            if (pet1 < pet2) return -1;
            if (pet1 > pet2) return 1;
          } else {
            if (pet1 === pet2) {
              return date2 - date1;
            }
            if (pet1 < pet2) return 1;
            if (pet1 > pet2) return -1;
          }
          return 0;
        });
        break;

      case "Status":
        stateData.sort((claim1, claim2) => {
          let status1 = claim1.Status.toLowerCase();
          let status2 = claim2.Status.toLowerCase();
          let date1 = new Date(claim1.DateSubmitted);
          let date2 = new Date(claim2.DateSubmitted);
          if (this.state.sortOrder === "ascending") {
            if (status1 === status2) {
              return date1 - date2;
            } else
              return (
                statusSortOrder.indexOf(status1) -
                statusSortOrder.indexOf(status2)
              );
          } else {
            if (status1 === status2) {
              return date2 - date1;
            } else
              return (
                statusSortOrder.indexOf(status2) -
                statusSortOrder.indexOf(status1)
              );
          }
        });
        break;

      default:
        break;
    }

    this.setState({
      sortColumn: id,
      sortOrder:
        this.state.sortOrder === "ascending" ? "descending" : "ascending",
      dataSource: stateData
    });

    event.stopPropagation();
  }

  checkBox = selectedRowId => {
    const isRowSelected =
      this.state.selectedRowId === selectedRowId ? true : false;
    return isRowSelected === true ? (
      <img src="../../assets/images/checkbox-checked.png" alt="cheked" />
    ) : (
      <img src="../../assets/images/checkbox-unchecked.png" alt="cheked" />
    );
  };

  selectTableRow = (event, id) => {
    if (id === this.state.selectedRowId) {
      this.setState({ selectedRowId: "" });
      this.props.setRelatedClaimId("");
    } else {
      this.setState({ selectedRowId: id });
      this.props.setRelatedClaimId(id);
    }    
    event.stopPropagation();
  };

  createTableHeader = () => {
    return this.state.dataSource.length > 1 ? (
      <div className="table-component-header">
        {TableHeader.map(
          ({
            header1,
            header,
            id,
            visibleInMobile,
            isSortable,
            desktopWidth,
            mobileWidth
          }) => {
            const mobileWid =
              mobileWidth === undefined ? desktopWidth : mobileWidth;
            let classes = visibleInMobile
              ? `col-${mobileWid} col-md-${desktopWidth} text-center no-padding-cell-content-mobile`
              : `d-none d-md-block col-${mobileWid} col-md-${desktopWidth} text-center no-padding-cell-content-mobile`;

            return (
              <div
                key={id}
                className={classes}
                id={id}
                onClick={event => this.toggleSort(id, event)}
              >
                <span className="d-none d-md-inline-block">{header1}</span>{" "}
                {header}
                {isSortable && (
                  <i
                    className={
                      this.state.sortColumn === id &&
                      this.state.sortOrder === "ascending"
                        ? "ml-1 fa fa-sort-down"
                        : this.state.sortColumn === id &&
                          this.state.sortOrder === "descending"
                        ? "ml-1 fa fa-sort-up"
                        : "ml-1 fa fa-sort"
                    }
                  />
                )}
              </div>
            );
          }
        )}
      </div>
    ) : null;
  };

  paginationComponent = () => {
    return (
      <div className="pagination-container">
        <div className="float-left">
          <span className="d-none d-md-block">
            Showing {this.state.currentPage} to {this.totalPages} of{" "}
            {this.totalPages} enteries
          </span>
          <span className="d-block d-md-none">
            Showing {this.state.currentPage} of {this.totalPages} pages
          </span>
        </div>
        <div className="float-right">
          <div className="d-none d-md-block">
            <span
              className={
                "pagination-text-span " +
                (this.state.currentPage === 1
                  ? "pagination-text-span-disabled"
                  : "")
              }
              onClick={evt => this.previousPage(evt)}
            >
              <strong>Previous</strong>
            </span>
            <span style={{ padding: "0px 25px" }}>
              {this.state.currentPage}
            </span>
            <span
              className={
                "pagination-text-span " +
                (this.state.currentPage === this.totalPages
                  ? "pagination-text-span-disabled"
                  : "")
              }
              style={{ cursor: "pointer" }}
              onClick={evt => this.nextPage(evt)}
            >
              <strong>Next</strong>
            </span>
          </div>
          <div className="d-block d-md-none">
            <span
              onClick={evt => this.previousPage(evt)}
              className={
                "pagination-text-span " +
                (this.state.currentPage === 1
                  ? "pagination-text-span-disabled"
                  : "")
              }
              style={{ fontSize: 18, fontWeight: 800 }}
            >
              <i className="fa fa-angle-left" />{" "}
            </span>
            <span style={{ padding: "0px 25px" }}>
              {this.state.currentPage}
            </span>
            <span
              className={
                "pagination-text-span " +
                (this.state.currentPage === this.totalPages
                  ? "pagination-text-span-disabled"
                  : "")
              }
              onClick={evt => this.nextPage(evt)}
              style={{ fontSize: 18, fontWeight: 800, paddingLeft: 5 }}
            >
              <i className="fa fa-angle-right" />{" "}
            </span>
          </div>
        </div>
      </div>
    );
  };

  createSingleCell = (headerProps, data , index) => {
    const mobileWidth = headerProps.mobileWidth;
    const desktopWidth = headerProps.desktopWidth;
    const mobileWid = mobileWidth === undefined ? desktopWidth : mobileWidth;
    let classes = headerProps.visibleInMobile
      ? `col-${mobileWid} col-md-${desktopWidth} text-center no-padding-cell-content-mobile text-truncate`
      : `d-none d-md-block col-${mobileWid} col-md-${desktopWidth} text-center no-padding-cell-content-mobile text-truncate`;

    switch (headerProps.dataType) {
      case "CheckBox":
        return (
          <div
            key={index + data.ClaimID}
            onClick={evt => this.selectTableRow(evt, data.ClaimID)}
            className={classes}
          >
            {this.checkBox(data.ClaimID)}
          </div>
        );
      case "String":
        return <div key={index + data.ClaimID} className={classes}>{(data[headerProps.id] === null || data[headerProps.id] === undefined) ? "n/a" : data[headerProps.id]}</div>;
      default:
        return null;
    }
  };

  createTableRows = () => {
    this.dataToShow = this.state.dataSource.slice(
      (this.state.currentPage - 1) * this.dataPerPage,
      this.state.currentPage * this.dataPerPage
    );

    if (this.state.dataSource.length % this.dataPerPage === 0)
      this.totalPages = this.state.dataSource.length / this.dataPerPage;
    else
      this.totalPages =
        Math.floor(this.state.dataSource.length / this.dataPerPage) + 1;

    return (
      <div className="table-component-striped-table">
        {this.dataToShow.map((data, index) => (
          <div className="table-component-item" key={data.ClaimID + index}>
            <div className="d-flex">
              {TableHeader.map((props,index) => this.createSingleCell(props, data , index))}
            </div>
          </div>
        ))}
      </div>
    );
  };

  render() {
    return (
      <div id="table-component">
        {this.createTableHeader()}
        {this.createTableRows()}
        {this.paginationComponent()}
      </div>
    );
  }
}

const TableHeader = [
  {
    header: "",
    id: "checkbox",
    isSortable: false,
    desktopWidth: 1,
    dataType: "CheckBox",
    visibleInMobile: true,
    mobileWidth: 2
  },
  {
    header1: "Submitted",
    header: "Date",
    id: "DateSubmitted",
    isSortable: true,
    dataType: "String",
    visibleInMobile: true,
    desktopWidth: 3,
    mobileWidth: 4
  },
  {
    header: "Claim #",
    id: "ClaimNumber",
    isSortable: true,
    dataType: "String",
    visibleInMobile: true,
    desktopWidth: 4,
    mobileWidth: 6
  },
  {
    header: "PetName",
    id: "PetName",
    isSortable: true,
    visibleInMobile: false,
    dataType: "String",
    desktopWidth: 2,
    mobileWidth: 3
  },
  {
    header: "Status",
    id: "Status",
    dataType: "String",
    isSortable: true,
    visibleInMobile: false,
    desktopWidth: 2,
    mobileWidth: 3
  }
];
